import React, { Dispatch } from "react";
interface Props {
  selectedHeight: string;
  setSelectedHeight: Dispatch<React.SetStateAction<string>>;
  maximumHeight: number;
  minimumHeight: number;
}
const heightOptions = (minHeight: number, maxHeight: number) => {
  let selectedHeight = Number(maxHeight);
  const heights = [];
  while (selectedHeight >= Number(minHeight)) {
    heights.push(selectedHeight);
    selectedHeight -= 0.5;
  }
  return heights;
};
const ProductCutDownSelectHeight = ({
  selectedHeight,
  setSelectedHeight,
  maximumHeight,
  minimumHeight
}: Props) => {
  return <div className="cutdown__form form" data-sentry-component="ProductCutDownSelectHeight" data-sentry-source-file="ProductCutDownSelectHeight.tsx">
      <label htmlFor="chooseHeight">Choose a Table Height</label>
      <div className="form__control-container">
        <select id="chooseHeight" data-testid="chooseHeight" className="form__control" name="chooseHeight" value={selectedHeight} onChange={event => {
        setSelectedHeight(event.target.value);
      }}>
          {heightOptions(minimumHeight, maximumHeight).map(height => <option key={height} value={height}>
              {`${height}"`}
            </option>)}
        </select>
        <label htmlFor="chooseHeight" className="form__label">
          Table Height
        </label>
        <i className="icon-down-micro form__control-icon form__control-icon--lg" />
      </div>
      <span className="help-text" style={{
      fontSize: "12px",
      lineHeight: "1.2em",
      color: "#888"
    }}>
        Note: ADA requires table heights to be between 28 and 34 inches.
      </span>
    </div>;
};
export default ProductCutDownSelectHeight;